import load from 'sdk/reportType';
import { takeEvery } from 'redux-saga/effects';
import { LOAD } from 'model/reportType';
import { callAction } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      type: LOAD,
    })
  );
}
